import React, { useEffect } from "react";
import Modal, { ModalBody, ModalFooter } from "Components/Modal";
import { useIntl } from "react-intl";
import { Button, Tooltip } from "@gpstrackit/gtc-react-controls";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteHistoryIncidents,
  searchHistoryIncidents,
  sendGenericExport,
  openHistoryOverViewIncident,
} from "Redux/actions";
import { NotificationManager } from "Components/Notifications";
import { reset } from "../../redux/slice";

const Delete = ({ listDelete, open, setOpen, filters, pagination, setSelectedItems, tableRef }) => {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  const {
    resDelete: res,
    loadingResDelete: loading,
    errorResDelete: errorRes,
  } = useSelector((state) => state.historyIncidentsRedux);


  useEffect(() => {
    if (loading) return;
    if (!loading && res) {
      dispatch(searchHistoryIncidents(filters));
      NotificationManager.success(
        messages["deleteMessage_incident_history"],
        messages["deleteMessageTitle_incident_history"],
        3000,
        null,
        null,
        "success",
        null
      );
    }
    dispatch(reset({
      resDelete: null, 
      loadingResDelete: false,
      errorResDelete: null
    }))
    setSelectedItems([])
    tableRef?.current?.setSelectedItems([])
    pagination?.setSelectedItems([])
    return setOpen(false);
  }, [res, loading]);

  const deleteAction = () => {
    const ids = listDelete?.map((item) => item?.id);
    dispatch(deleteHistoryIncidents({ ids }));
  };

  return (
    <Modal
      title={messages["delete_incident_history"]}
      open={open}
      position="right"
      size="small"
      style={{ overflow: "hidden" }}
      className="overflow-hidden"
      handleClose={() => setOpen(false)}
    >
      <ModalBody
        style={{
          overflow: "hidden",
          marginBottom: 0,
          overflowY: "auto",
          height: "80vh",
        }}
      >
        <div style={{ padding: "20px" }}>
          {messages["delete_message_incident_history"]}
        </div>
        <div>
          {listDelete?.map((item) => {
            let name = item?.name
            if(name?.length > 20){
                return (
                    <p style={{ marginLeft: "20px" }}>
                        <Tooltip title={name}>
                            * {name.slice(0, 20) + "..."}
                        </Tooltip>
                    </p>
                )
            }else{
                return <p style={{ marginLeft: "20px" }}>* {item?.name}</p>
            }
          })}
        </div>
      </ModalBody>

      <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
        <div style={{ display: "flex", width: "100%", justifyContent: "end" }}>
          <Button
            style={{ marginRight: "5px" }}
            disabled={loading}
            onClick={() => setOpen(false)}
            className="btn-cancel"
          >
            {messages["cancel"]}
          </Button>

          <Button
            disabled={loading}
            onClick={(e) => {
              if (e) e.preventDefault();
              deleteAction();
            }}
            className="btn-red"
          >
            {messages["delete"]}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default Delete;
